(() => {
  App.ui = App.ui || {};

  const name = 'loader';

  App.ui[name] = (() => {
    /**
     * adds the overlay and classnames
     * @param {object} $container - object to cover
     */
    const start = function ($container) {
      const fixed = $container.prop('tagName').toLowerCase() === 'body';
      let count = $container.data('loadingoverlay') || 0;
      let $overlay = null;

      if (count === 0) {
        $overlay = $('<div />', {
          class: 'loadingoverlay',
        });

        if (fixed) {
          $overlay.css({
            position: 'fixed',
          });
        } else {
          $overlay.css({
            position: 'absolute',
            width: $container.innerWidth(),
            height: $container.innerHeight(),
          });
          if ($container.css('position') === 'static') {
            $overlay.css({
              top: $container.position().top + parseInt($container.css('margin-top'), 10) + parseInt($container.css('border-top-width'), 10),
              left: $container.position().left + parseInt($container.css('margin-left'), 10) + parseInt($container.css('border-left-width'), 10),
            });
          }
        }
        count += 1;
        $overlay
          .append($(`<img alt="loading..." src="${texts('loader@pList')}" class="spinner-animated visible center"/>`));
        $container
          .addClass('loading')
          .append($overlay)
          .data('loadingoverlay', count);
      }
    };

    /**
     * removes the overlay and classnames
     * @param {object} $container - object to uncover
     */
    const stop = function ($container) {
      let count = $container.data('loadingoverlay');
      if (count === undefined) {
        return;
      }
      count -= 1;
      if (count <= 0) {
        $container
          .removeClass('loading')
          .removeData('loadingoverlay')
          .children('.loadingoverlay').remove();
      } else {
        $container
          .attr('data-loadingoverlay', count);
      }
    };

    return {
      start($elements, options) {
        if ($elements) {
          $elements.each((ind, elem) => {
            start($(elem), options);
          });
        } else {
          App.sendErrorToRaygun('loader: no element provided to show loader');
        }
      },
      stop($elements) {
        if ($elements) {
          $elements.each((ind, elem) => {
            stop($(elem));
          });
        } else {
          App.sendErrorToRaygun('loader: no element provided to hide loader');
        }
      },
    };
  })();
})();
